import { motion } from "framer-motion";
import type { ReactNode } from "react";
import type { FadeInOutOptions } from "@/utils/fadeInOut.js";
import { fadeInOut } from "@/utils/fadeInOut.js";


interface FadingDivProps {
    children: ReactNode;
    options?: FadeInOutOptions;
    [prop: string]: unknown;
}

export function FadingDiv({ children, options, ...props }: FadingDivProps) {
    return (
        <motion.div
            {...fadeInOut({
                duration: 0.5,
                ...options,
            })}
            {...props}>

            {children}
        </motion.div>
    );
}
